import { ContentBodyFormat, ValidationErrorCode } from '@today/types'
import { z } from 'zod'

/**
 * `POST /content/resolve` 200 body and the ADR-0047 `ContentReadPort` resolution
 * (TO-429). Published in the OpenAPI document and used by the port contract
 * tests, so the port and the route are pinned to one shape.
 */
const contentResolvedItemResponseSchema = z.strictObject({
	textId: z.uuid(),
	code: z.string(),
	title: z.string(),
	body: z.string(),
	bodyFormat: z.enum(ContentBodyFormat),
	locale: z.string(),
	versionNumber: z.number().int().min(1),
	localizationId: z.uuid(),
	contentSha256: z.string().regex(/^[0-9a-f]{64}$/),
	productIds: z.array(z.uuid()),
})

export const contentResolutionResponseSchema = z.strictObject({
	locale: z.string(),
	at: z.string(),
	byProduct: z.record(z.uuid(), z.array(contentResolvedItemResponseSchema)),
	pageEnd: z.array(contentResolvedItemResponseSchema),
})

/** Non-empty, ordered by code; one entry per missing text code. */
export const contentMissingTextsSchema = z
	.array(z.strictObject({ code: z.string(), locale: z.string(), textId: z.uuid(), productIds: z.array(z.uuid()) }))
	.min(1)
	.refine((missing) => missing.every((m, i) => i === 0 || missing[i - 1].code < m.code), 'ordered by code')

/** `POST /content/resolve` 422 body when an assigned text has no localization in force (TO-429 REQ-003). */
export const contentTextNotAvailableErrorSchema = z.strictObject({
	error: z.strictObject({
		code: z.literal(ValidationErrorCode.TEXT_NOT_AVAILABLE),
		message: z.string().startsWith('TEXT_NOT_AVAILABLE: '),
		details: z.strictObject({ missing: contentMissingTextsSchema }),
	}),
})
